/**
 * @file コンポーネント：フル動画ページ編集モーダル症例タグリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { SearchSelect } from "~/src/components/projects/SearchSelect";
import { Button } from "~/src/components/uiparts/Button";

// スタイル読み込み
import {
    StyledContents,
    StyledContentsSearch,
    StyledContentsSearchItem,
    StyledContentsSelected,
    StyledContentsSelectedItem,
    StyledContentsSelectedItemButton,
    StyledContentsSelectedItemButtonIcon,
    StyledContentsSelectedItemButtonText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "cancel",
                    onClick: (e) => {
                        e.preventDefault();
                        props.setIsOpenModalEdit(false);
                    },
                    text: localized["Label.Cancel"],
                },
                {
                    buttonType: "submit",
                    onClick: (e) => props.fnOnClickSave(e),
                    text: localized["Label.Save"],
                },
            ]}
            content={[
                <StyledContents key="contents">
                    {/* 一時保存リスト */}
                    <StyledContentsSelected>
                        {props.listTempSelected.map((item, index) => (
                            <StyledContentsSelectedItem key={"tag-" + index}>
                                <StyledContentsSelectedItemButton
                                    data-id={item.id}
                                    onClick={(e) => props.fnOnClickDelete(e)}
                                >
                                    <StyledContentsSelectedItemButtonIcon>
                                        <i className="fas fa-times"></i>
                                    </StyledContentsSelectedItemButtonIcon>
                                    <StyledContentsSelectedItemButtonText>
                                        {item.name}
                                    </StyledContentsSelectedItemButtonText>
                                </StyledContentsSelectedItemButton>
                            </StyledContentsSelectedItem>
                        ))}
                    </StyledContentsSelected>
                    {/* 候補リスト */}
                    <StyledContentsSearch>
                        <StyledContentsSearchItem>
                            <SearchSelect
                                isWide={true}
                                list={props.listSearch}
                                name="modaleditsearchselect"
                                onColor="white"
                                value=""
                            />
                        </StyledContentsSearchItem>
                        <StyledContentsSearchItem>
                            <Button
                                buttonType="main"
                                href="#"
                                onClick={(e) => props.fnOnClickAdd(e)}
                                onColor="white"
                                text={localized["Label.Add"]}
                            />
                        </StyledContentsSearchItem>
                    </StyledContentsSearch>
                </StyledContents>,
            ]}
            hasButtonClose={true}
            headline={props.label}
            isShow={props.isOpenModalEdit}
            setIsShow={props.setIsOpenModalEdit}
        />
    );
};
